// we only take event and properties which will populate google analytics label field
window.trackGoogleTagEvent = function(eventName, properties){
  function formatProps(){
    if (_.isEmpty(properties))
      return {};
    else {
      if(_.isObject(properties)){
        return { 'ga-label': JSON.stringify(properties) };
      }
      else{
        return { 'ga-label': properties };
      }
    }
  }

  // Search for the user id in the dataLayer array
  // every event name is prepended with dc. so we route it properly from google tag manager,
  // yet real actual sent to google analytics is the eventName without dc.
  var user_props = {}

  // Determine user_id and email
  dataLayer.forEach(function(element){
    if ( element['user_id'] ) {
      user_props = { 'user_id': element['user_id'] };

      if ( element['email'] ) {
        user_props['email']  = element['email'];
      }

      if ( element['type'] ) {
        user_props['type']  = element['type'];
      }
    }
  })
  dataLayer.push(_.merge({ 'event': 'dc.' + eventName }, formatProps(), user_props));
}
